<template>
  <div>
    <!-- Overlay + Spinner -->
    <div v-if="!appReady" class="overlay">
      <div class="spinner"></div>
      <p class="loading-text">Iniciando RCAR...</p>
    </div>

    <!-- Contenido real de la app -->
    <div v-else>
      <router-view />
      <!-- o <AppContent /> / tu contenido principal -->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useSession } from '@/composables/useSession'

const { token, loginPublic, userData, isAccessTokenExpired } = useSession()


const appReady = ref(false)

onMounted(async () => {
  try {
    // Si no existe token o es de usuario público, o si el token está expirado,
    // inicia sesión como público.
    if (!token.value || userData?.value.name?.toLowerCase() === 'public' || isAccessTokenExpired()) {
      const result = await loginPublic()
      if (result == null) {
        appReady.value = false;
      } else {
        appReady.value = true;
      }
    } else {
      appReady.value = true;
    }
  } catch (error) {
    console.error('Error en login:', error)
  }
})
</script>

<style scoped>
/* Overlay que cubre toda la pantalla */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  /* Semitransparencia para que se vea un poco oscuro */
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;

  /* Centrar el contenido */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Spinner CSS sencillo */
.spinner {
  width: 50px;
  height: 50px;
  border: 6px solid #ccc;
  border-radius: 50%;
  border-top-color: #07d;
  animation: spin 0.8s ease infinite;
}

/* Animación de giro */
@keyframes spin {
  0% {
      transform: rotate(0deg);
    }
  
    100% {
      transform: rotate(360deg);
    }
}

/* Texto de carga */
.loading-text {
  margin-top: 16px;
  color: #ffffff;
  font-size: 1.2rem;
  font-weight: 500;
}
</style>
